import { render, staticRenderFns } from "./OncologiaPreguntas.vue?vue&type=template&id=4ca1a14e"
import script from "./OncologiaPreguntas.vue?vue&type=script&lang=js"
export * from "./OncologiaPreguntas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports